import React from 'react';
import Grid from '@mui/material/Grid';
import Switch from '@mui/material/Switch';
import { FreeUserWarning, StyledInstructions } from '../CodeStyle';
import { useNavigate } from 'react-router-dom';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import LanguageIcon from '@mui/icons-material/Language';
import { Tooltip } from '@mui/material';

const InternetAccessSection = ({ classes, onInternetEnabledChange, isFreeUserTier, store }) => {
  const isInternetEnabled = store ? store.getState().isInternetEnabledInStore() : false;
  const data = store ? store.getState().data : {};
  const codeLang = (data && data.codeLang) || 'python_3_9';
  const navigate = useNavigate();

  const clientLibrary = codeLang === 'nodejs_16' ? 'axiosClient' : 'requestsClient';
  const importLibrary = codeLang === 'nodejs_16' ? 'axios' : 'requests';

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{ padding: '4px 0' }}
        >
          <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
            <LanguageIcon sx={{ marginRight: '8px', fontSize: '20px' }} />
            <span className={classes?.label ?? ''}>Internet Access</span>
          </Grid>
          <Grid item>
            <Switch
              checked={isInternetEnabled}
              onChange={value => onInternetEnabledChange(value.target.checked)}
              inputProps={{ 'aria-label': 'controlled' }}
              disabled={isFreeUserTier}
              size="small"
            />
          </Grid>
        </Grid>
      </Grid>

      {isFreeUserTier && (
        <Grid item xs={12}>
          <FreeUserWarning>
            This is a premium feature available to paid plans only.{' '}
            <span
              onClick={() => {
                navigate('/organization');
              }}
              className="linkStyle"
            >
              Upgrade now
            </span>
          </FreeUserWarning>
        </Grid>
      )}

      {isInternetEnabled && !isFreeUserTier && (
        <Grid item xs={12}>
          <StyledInstructions>
            <Grid container alignItems="center" sx={{ marginBottom: '8px' }}>
              <InfoOutlinedIcon sx={{ marginRight: '8px', color: '#55A77A' }} />
              <strong>How to make secure internet requests:</strong>
            </Grid>
            <div style={{ padding: '0 4px' }}>
              Use <b>{clientLibrary}</b> to securely make requests using secrets or credentials - do
              not import <b>{importLibrary}</b> directly in your code
            </div>
          </StyledInstructions>
        </Grid>
      )}
    </Grid>
  );
};

export default InternetAccessSection;
